import { FormGroup, ValidationErrors } from '@angular/forms';

export class PasswordUtils {
  static getScrollPosition() {
    const x = (window.scrollX !== undefined)
      ? window.scrollX
      : (document.documentElement || document.body.parentNode || document.body)['scrollLeft'];

    const y = (window.scrollY !== undefined)
      ? window.scrollY
      : (document.documentElement || document.body.parentNode || document.body)['scrollTop'];

    return {x, y};
  }

  static samePasswordValidator(group: FormGroup): ValidationErrors {
    if (group && group.controls && group.controls['password'].value
        !== group.controls['passwordConfirmation'].value) {
      const errors = {pwdDoesNotMatch: true};
      group
        .controls['passwordConfirmation']
        .setErrors(errors);
      return errors;
    }
    return {};
  }
}
